"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoodTransactionHistoryResponsePaginationToJSON = exports.FoodTransactionHistoryResponsePaginationFromJSONTyped = exports.FoodTransactionHistoryResponsePaginationFromJSON = void 0;
var runtime_1 = require("../runtime");
function FoodTransactionHistoryResponsePaginationFromJSON(json) {
    return FoodTransactionHistoryResponsePaginationFromJSONTyped(json, false);
}
exports.FoodTransactionHistoryResponsePaginationFromJSON = FoodTransactionHistoryResponsePaginationFromJSON;
function FoodTransactionHistoryResponsePaginationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'total': !(0, runtime_1.exists)(json, 'total') ? undefined : json['total'],
        'limit': !(0, runtime_1.exists)(json, 'limit') ? undefined : json['limit'],
        'offset': !(0, runtime_1.exists)(json, 'offset') ? undefined : json['offset'],
        'hasMore': !(0, runtime_1.exists)(json, 'hasMore') ? undefined : json['hasMore'],
    };
}
exports.FoodTransactionHistoryResponsePaginationFromJSONTyped = FoodTransactionHistoryResponsePaginationFromJSONTyped;
function FoodTransactionHistoryResponsePaginationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'total': value.total,
        'limit': value.limit,
        'offset': value.offset,
        'hasMore': value.hasMore,
    };
}
exports.FoodTransactionHistoryResponsePaginationToJSON = FoodTransactionHistoryResponsePaginationToJSON;
